/**
 * CitationSuperscript — Inline [1] citation markers in chat responses.
 *
 * Renders a gold superscript number that opens the SourceDrawer on click.
 * Tooltip on hover shows the source label.
 */

import React, { useState } from 'react';
import { C } from '../design-system/primitives/constants';

const KIND_COLORS = {
  bigquery: { bg: `${C.gen}20`, border: `${C.gen}40`, text: C.gen },
  natstat: { bg: `${C.elite}20`, border: `${C.elite}40`, text: C.elite },
  web: { bg: '#9333ea20', border: '#9333ea40', text: '#a855f7' },
  vertex_search: { bg: '#06b6d420', border: '#06b6d440', text: '#22d3ee' },
};

export function CitationSuperscript({ refNum, label, kind, onClick }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const colors = KIND_COLORS[kind] || KIND_COLORS.bigquery;

  return (
    <span className="relative inline-block">
      <button
        onClick={onClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold rounded-md transition-all duration-200 cursor-pointer align-super -mt-1 hover:brightness-125"
        style={{
          background: colors.bg,
          border: `1px solid ${colors.border}`,
          color: colors.text,
        }}
        aria-label={`Citation ${refNum}: ${label}`}
      >
        {refNum}
      </button>
      {showTooltip && (
        <span
          className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2.5 py-1 rounded-lg text-[11px] font-medium whitespace-nowrap pointer-events-none shadow-xl"
          style={{ background: C.s3, border: `1px solid ${C.border}`, color: C.t2 }}
        >
          {label}
        </span>
      )}
    </span>
  );
}

export default CitationSuperscript;
